export const replaceCountryCode = (mobileNo: string | null | undefined) => {
  if (!mobileNo) return "";
  const digits = String(mobileNo).replace(/\D/g, "");

  return digits.slice(-10);
};

export const getCountryCode = (mobileNo: string | null | undefined) => {
  if (!mobileNo) return "";
  const digits = String(mobileNo).replace(/\D/g, "");
  if (digits.length <= 10) return "";

  const countryCode = digits.slice(0, digits.length - 10);

  return `+${countryCode}`;
};
